import CryptoJS from 'crypto-js'

const KEY = CryptoJS.enc.Utf8.parse('ELNaesKey@2024!1')
const IV = CryptoJS.enc.Utf8.parse('ELNaesIv@2024!11')

export function encryptAES(plainText) {
  if (!plainText) {
    return plainText
  }
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js